module.exports = __webpack_public_path__ + "img/banner.ec42937a.png";